import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link was sent.");
    } catch {
      toast.error("Could not send email. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="forgot-page">
      <div className="w-full max-w-md bg-[#0a0a0a] border border-white/10 rounded-2xl p-10">
        <h1 className="text-3xl font-black mb-2" style={{ fontFamily: "Outfit" }}>Reset password</h1>
        <p className="text-sm text-[#aaa] mb-6">Enter your email and we'll send a reset link.</p>
        {sent ? (
          <div className="text-center text-sm text-[#ccc] py-6">
            Check your inbox for further instructions.
            <div className="text-xs text-[#666] mt-2">(Email may take a minute. Don't forget to check spam.)</div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" placeholder="you@email.com" data-testid="forgot-email-input" />
            <button type="submit" disabled={loading} className="w-full btn-primary justify-center" data-testid="forgot-submit-btn">{loading ? "Sending..." : "Send reset link"}</button>
          </form>
        )}
        <Link to="/login" className="block mt-5 text-center text-sm text-[#aaa] hover:text-white">Back to sign in</Link>
      </div>
    </div>
  );
}
